<template>
    <div class="subscription-uploaded-documents">
        <div class="row">
            <div class="col-12 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.own_documents')" :full-width="true">
                    <template v-slot:action>
                        <span class="text-link d-none d-md-inline-block" @click="openModal">{{$t('cdb.subscriptions.upload_file')}}</span>
                        <button type="button" class="btn btn-secondary d-block d-md-none mt-4" @click="openModal">
                            {{$t('cdb.subscriptions.upload_file')}}
                        </button>
                    </template>
                </data-entry-column>

                <subscription-document-list
                    :documents="userUploads"
                    v-if="userUploads.length"
                    class="mb-3"
                ></subscription-document-list>
            </div>
        </div>
    </div>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import { EventBus } from "../../event-bus"
import SubscriptionDocumentList from "./SubscriptionDocumentList.vue";

export default {
    name: 'SubscriptionUploadedDocuments',
    components: {
        SubscriptionDocumentList,
        DataEntryColumn
    },
    props: {
        subscriptionData: null,
        userUploads: null
    },
    methods: {
        openModal() {
            EventBus.$emit('init-upload-modal', { subscriptionData: this.subscriptionData });
        },
        handleDownloadClicked(event, link) {
            this.$emit('download-clicked', event, link);
        }
    },
    created() {
        EventBus.$on('download-clicked', this.handleDownloadClicked);
    },
    beforeDestroy() {
        EventBus.$off('download-clicked', this.handleDownloadClicked);
    },
}
</script>
